import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Comprehensive ResizeObserver error suppression
const suppressResizeObserverErrors = () => {
  // Suppress console errors
  const consoleError = console.error;
  console.error = (...args) => {
    if (
      args[0]?.includes?.('ResizeObserver') ||
      args[0]?.message?.includes?.('ResizeObserver')
    ) {
      return;
    }
    consoleError(...args);
  };

  // Suppress window errors
  window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  });

  // Suppress unhandled rejection errors
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  });
};

suppressResizeObserverErrors();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
